// Or from '@reduxjs/toolkit/query' if not using the auto-generated hooks
import { createApi } from '@reduxjs/toolkit/query/react';
import { PaginatedDataResponse, Response } from 'common/types';
import { baseQuery } from 'redux/reducers/settings';
import { IOrganizationHallResponse } from '../organization-halls';
import { ITrainingTypeResponse } from '../training-type';

export interface IAttendanceResponse extends IAttendanceInput {
  routine_details: IRoutineDetails; // routine remanint
  trainee_details: ITrainingTypeResponse;
  hall_details: IOrganizationHallResponse;
  approved_by_details: IApprovedByDetails; // approved_by_details remaingin
}

export interface IAttendanceInput {
  attendance_id?: number;
  UserPin?: number;
  VerifyType: boolean;
  Temperature: string;
  DeviceSn: string;
  BranchCode: string;
  VerifyTime: string;
  status: number;
  check_in: string;
  check_out: string;
  reason: string;
  requested_date: string;
  approved_by: number;
  approved_date: string;
  id?: number;
}

export interface IMannualAttendanceInput {
source: string;
  reason: string;
  branch_code: string;
  temperature: number;
  verify_type: boolean;
  verify_time: string;
  status: boolean;
  check_in: string;
  check_out: string;
  approved_date: string;
  requested_date: string;
  user_id: number;
  approved_by_id: number;
  routine_id: number;
  hall_id: number;
  day_session_id: number;
  selectedUsers: number[]; // Add selectedUsers field to the interface
}
export interface IRoutineDetails {
  id: number;
  name: string;
}
export interface IApprovedByDetails {
  id: number;
  email: string;
}

export interface IPageQueryParams {
  page?: number | void;
  pageSize?: number | void;
  start_date?: string;
  routineId?: string;
  end_date?: string;
  query?: string;
  offset?: string;
}

export interface IPageAttendanceQueryParams {
  date?: string;
  routineId?: string;
  sessionId?: string;
  query?: string;
    page?: number | void;
  pageSize?: number | void;
  
}



export interface IAttendance {
  approved_by: number | null;
  approved_date: string;
  branch_code: string;
  check_in: string;
  check_out: string;
  id: number;
  reason: null;
  requested_date: string;
  source: string;
  status: boolean;
  temperature: number;
  user_id: number;
}

export const attendanceApi: { [key: string]: any } = createApi({
  reducerPath: 'attendanceApi',
  baseQuery: baseQuery,
  tagTypes: ['Attendance'],
  endpoints: (build) => ({
    listAttendance: build.query<
      Response<PaginatedDataResponse<IAttendanceResponse[]>>,
      IPageAttendanceQueryParams | null
    >({
      query: (paging) => {
        const sessionId = paging?.sessionId ?? 0;
        const routinedId = paging?.routineId;
        return `attendance/list/?sessionId=${sessionId}&date=${paging?.date ?? ''}&routineId=${
          routinedId ?? ''
        }&query=${paging?.query ?? ''}`;
      },

      keepUnusedDataFor: 0,
      // providesTags: [{ type: 'Attendance', id: 'PARTIAL-LIST' }]
      providesTags: (result, error, page) =>{
        return(
             result 
          ? [
              ...result.data.map(({ attendance_id }: { attendance_id: number }) => ({
                type: 'Attendance' as const,
                id: attendance_id
              })),
              { type: 'Attendance', id: 'PARTIAL-LIST' }
            ]
          : [{ type: 'Attendance', id: 'PARTIAL-LIST' }]

        )

      }
     
    }),

     listAutoAttendance: build.query<
      Response<PaginatedDataResponse<IAttendanceResponse[]>>,
      IPageAttendanceQueryParams | null
    >({
      query: (paging) => {
        const routinedId = paging?.routineId;

            return `attendance/all-detail/list/?pageNo=${paging?.page}&pageSize=${paging?.pageSize}&routineId=${routinedId ?? ''}&date=${paging?.date ?? ''}`
            
            // &start_date=${paging?.start_date}&end_date=${paging?.end_date}&query=${paging?.query};

      },

      keepUnusedDataFor: 0,
      // providesTags: [{ type: 'Attendance', id: 'PARTIAL-LIST' }]
      providesTags: (result, error, page) =>
        result && result.results
          ? [
              ...result.results.data.map(({ attendance_id }: { attendance_id: number }) => ({
                type: 'Attendance' as const,
                id: attendance_id
              })),
              { type: 'Attendance', id: 'PARTIAL-LIST' }
            ]
          : [{ type: 'Attendance', id: 'PARTIAL-LIST' }]
    }),

    listDailySession: build.query<
      Response<PaginatedDataResponse<IAttendanceResponse[]>>,
      IPageQueryParams | null
    >({
      query: (paging) => {
        const pageNo = paging?.page ?? 1;
        const pageSize = paging?.pageSize ?? 10;
        const routinedId = paging?.routineId;
        return `training/daily-sessions/list/?pageNo=${pageNo}&pageSize=${pageSize}&start_date=${
          paging?.start_date ?? ''
        }&routineId=${routinedId ?? ''}&query=${paging?.query ?? ''}`;
      },

      keepUnusedDataFor: 0,
      providesTags: (result, error, page) =>
        result && result.results
          ? [
              ...result.results.data.map(({ attendance_id }: { attendance_id: number }) => ({
                type: 'DailySession' as const,
                id: attendance_id
              })),
              { type: 'DailySession', id: 'PARTIAL-LIST' }
            ]
          : [{ type: 'DailySession', id: 'PARTIAL-LIST' }]
    }),
    createAttendance: build.mutation<IAttendanceResponse, IAttendanceInput>({
      query(body) {
        return {
          url: `attendance/manual-create-bulk`,
          method: 'POST',
          body
        };
      },
      invalidatesTags: [{ type: 'Attendance', id: 'PARTIAL-LIST' }]
    }),

    updateAttendance: build.mutation<IAttendanceResponse, IAttendanceInput>({
      // query(id: number, body: any) {
      //   return {
      //     url: `attendance/manual/update/${id}`,
      //     method: 'PATCH',
      //     body
      //   };
      // },
      query(body) {
        const { id } = body;
        return {
          url: `attendance/manual/update/${id}`,
          method: 'PATCH',
          body
        };
      },
      invalidatesTags: [{ type: 'Attendance', id: 'PARTIAL-LIST' }]
    }),
    deleteAttendance: build.mutation<IAttendanceResponse, string>({
      query(id) {
        return {
          url: `attendance/delete/${id}/`,
          method: 'DELETE'
        };
      },
      invalidatesTags: [{ type: 'Attendance', id: 'PARTIAL-LIST' }] // TODO:
    })
  })
});

export const {
  useListAttendanceQuery,
  useListAutoAttendanceQuery,

  useListDailySessionQuery,
  useCreateAttendanceMutation,
  useUpdateAttendanceMutation,
  useDeleteAttendanceMutation
} = attendanceApi;
